import React from "react";
import { AppButton } from "../../components";
import "./breadcrumbs.styles.css";

import { IonIcon, IonTitle, IonRouterLink } from "@ionic/react";
import { chevronBackOutline } from "ionicons/icons";
import { useHistory } from "react-router";

interface IBreadcrumbsProps {
  backButton?: boolean;
  // backButtonLink?: string;
  items: {
    title: string;
    link?: string;
  }[];
}

const Breadcrumbs = ({ backButton, items }: IBreadcrumbsProps) => {
  const history = useHistory();
  return (
    <div className="app-breadcrumbs">
      {backButton && (
        <AppButton buttonType="back" onClick={() => history.goBack()} className="app-back-button">
          <IonIcon icon={chevronBackOutline} />
          <span>Indietro</span>
        </AppButton>
      )}
      <IonTitle className="breadcrumbs-container">
        {items.map((item, i) => (
          <span key={i}>
            {item.link ? (
              <IonRouterLink href={item.link}> {item.title} </IonRouterLink>
            ) : (
              <span className="breadcrumb-align-fix"> {item.title} </span>
            )}
            {i < items.length - 1 && (
              <span className="app-breadcrumbs-chevron">
                <svg
                  width="7"
                  height="11"
                  viewBox="0 0 7 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.26703 9.59961L5.73294 5.23294L1.26703 0.866277"
                    stroke="#A2A2A2"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            )}
          </span>
        ))}
      </IonTitle>
    </div>
  );
};

export default Breadcrumbs;
